import config from "@/config"
import http from "@/utils/request"

export default {
	chat: {
		url: `${config.API_URL}/assistant/chat`,
		name: "使用助手问答",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	}
}
